import FormSelect from '@/agilis/components/Form/FormSelect/FormSelect.vue'
import Configuration from '@/agilis/util/Configuration'
import { mapGetters } from 'vuex'

export default {
  name: 'FormSelectPriceItem',

  props: {
    fieldConfig: Object,
    value: [Object, Array, String],
    formModel: Object
  },

  components: {
    FormSelect
  },

  data () {
    return {
      deepMode: false,
      showDeep: false
    }
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId'
    }),

    computedFieldConfig () {
      return Object.assign({}, this.fieldConfig, { filter: this.filterFn })
    },

    priceListConfiguration () {
      return Configuration.getTrackerType(this.applicationId, 'priceItem').priceList
    }
  },

  methods: {
    filterFn (priceItem) {
      const pId = this.fieldConfig.__pId

      if (this.deepMode === true || this.showDeep === false) {
        return true // no filter: show all items
      } else {
        return priceItem.priceListId === pId // filter ONLY main priceList
      }
    },

    getPriceListName (priceListId) {
      const priceList = this.priceListConfiguration[priceListId]
      return priceList && this.$t(priceList.name)
    },

    onItemsFetched (items = []) {
      const pId = this.fieldConfig.__pId

      let selectedItem = null
      if (this.$refs.select.multiple) {
        this.showDeep = false
        this.deepMode = true
        items = this.getPriceItemFromDocument(items)
      } else {
        this.showDeep = items.some(p => p.priceListId !== pId)
        if (this.fieldConfig.onProposition) {
          selectedItem = this.value ? items.find(item => item.id === this.value.originalPriceItemId) : null
          this.deepMode = selectedItem ? selectedItem.priceListId !== pId : false
        } else {
          selectedItem = this.value ? items.find(item => this.value.includes(item.productEnterpriseId)) : null
          this.deepMode = this.showDeep
        }
      }

      items = this.$refs.select.processItems(items) // after evaluating deepMode and showDeep we need to apply again the filter on the items
      this.$refs.select.items = items
      if (this.$refs.select.multiple) {
        selectedItem = items
      }
      if (selectedItem) {
        this.$refs.select.handleSelectChange(selectedItem)
      }
    },

    onSwitchMode (e) {
      e.stopPropagation()
      this.deepMode = !this.deepMode

      // Force select item re-processing
      this.$refs.select.forceProcessItems()
    },

    getPriceItemFromDocument (items) {
      const priceItemFromDocument = []
      if (this.formModel?.areaNode?.workpackages) {
        this.formModel.areaNode.workpackages.forEach(workpackage => {
          if (items.find(item => item.id === workpackage.priceItemId)) {
            let newItem = Object.assign({}, items.find(item => item.id === workpackage.priceItemId), workpackage)
            newItem.computedId = `${newItem.name} ${newItem.id}`
            priceItemFromDocument.push(newItem)
          }
        })
      }
      return priceItemFromDocument
    }
  }
}
